import { Builder } from '@builder.io/react';
import Hero from './Hero';

Builder.registerComponent(Hero, {
  name: 'Hero',
  inputs: [
    {
      name: 'heroImage',
      type: 'object',
      defaultValue: {
        alt: 'the hero image',
      },
      subFields: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'gif', 'svg'],
        },
        {
          name: 'alt',
          type: 'string',
        },
      ],
    },
    {
      name: 'heroTitle',
      type: 'string',
    },
  ],
});
